import type { DiscoverChatbotProfileOverlayLabels, DiscoverChatbotProfileOverlayProfile } from "@next-platform/client-common-core";
import { TextBox } from "@next-platform/client-common-spicy-ui";
import React from "react";

type SectionKey = "greeting" | "personality" | "scenario" | "exampleDialogue";

type Section = {
  readonly key: SectionKey;
  readonly testIDSuffix: string;
};

const SECTIONS: readonly Section[] = [
  { key: "greeting", testIDSuffix: "GreetingTextBox" },
  { key: "personality", testIDSuffix: "PersonalityTextBox" },
  { key: "scenario", testIDSuffix: "ScenarioTextBox" },
  { key: "exampleDialogue", testIDSuffix: "ExampleDialogueTextBox" },
];

type DiscoverChatbotProfileOverlaySectionsProps = {
  readonly profile: Pick<DiscoverChatbotProfileOverlayProfile, SectionKey>;
  readonly labels: Pick<DiscoverChatbotProfileOverlayLabels, SectionKey | "showMore" | "showLess">;
};

const DiscoverChatbotProfileOverlaySections = ({ profile, labels }: DiscoverChatbotProfileOverlaySectionsProps) => {
  const sections = SECTIONS.filter((section) => Boolean(profile[section.key]));

  if (sections.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 pt-2">
      {sections.map((section) => (
        <TextBox
          key={section.key}
          text={profile[section.key] ?? ""}
          label={labels[section.key]}
          showMoreLabel={labels.showMore}
          showLessLabel={labels.showLess}
        />
      ))}
    </div>
  );
};

export default React.memo(DiscoverChatbotProfileOverlaySections);
